import * as theme from '../../../theme';

export const FLAVOUR_COLOURS = {
	primary: '#3127B8',
	success: '#3EAC4D',
	warning: '#ffc300',
	danger: '#FF3B30',
	gray: theme.gray40,
};
